import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AuditorApp } from "./AuditorApp";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode><AuditorApp /></StrictMode>,
);
